import React from 'react';
import PropTypes from 'prop-types';
import ProfileDescriptorLink from '@/components/common/ProfileDescriptorLink';
import { useOwnerOrgPubId } from '@/lib/hooks/userData';

// EmployeeLink wrapper for profile descriptor, can be adjusted as needed if API changes
function EmployeeLink({ classes = {}, displayName, userId }) {
  const { ownerOrgId } = useOwnerOrgPubId();

  return (
    <ProfileDescriptorLink
      classes={classes}
      displayName={displayName}
      ownerOrgId={ownerOrgId}
      userId={userId}
    />
  );
}

EmployeeLink.propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string,
    link: PropTypes.string,
  }),
  displayName: PropTypes.string.isRequired,
  userId: PropTypes.string.isRequired,
};

EmployeeLink.defaultProps = {
  classes: {},
};

export default EmployeeLink;
